"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IVisibilidade = void 0;
var IVisibilidade;
(function (IVisibilidade) {
    IVisibilidade[IVisibilidade["publico"] = 0] = "publico";
    IVisibilidade[IVisibilidade["privado"] = 1] = "privado";
})(IVisibilidade = exports.IVisibilidade || (exports.IVisibilidade = {}));
//# sourceMappingURL=IVisibilidade.js.map